// extracted by mini-css-extract-plugin
export default {"wrapper":"ColumnsList_wrapper__fM1WT","lists":"ColumnsList_lists__jgm8h"};